import React from "react";
import WebHeader from "./common/WebHeader";
import WebFooter from "./common/WebFooter";

const WebLayout = ({ children }: any) => {
  return (
    <div className="">
      <WebHeader />
      {/* <!-- ===== Main Content Start ===== --> */}
      <main className="">{children}</main>
      {/* <!-- ===== Main Content End ===== --> */}
      <WebFooter />
    </div>
  );
};

export default WebLayout;
